<template>
    <li>
        <label class="check_wrap">
            <input type="checkbox" :checked="value.isSelected" @click="action_SelectCode">
            <span class="checkmark"></span>
            <span class="color_circle" :style="backgroundColorStyle" v-if="isServerData"></span>
            <span class="code_title">{{ codeTitle }}</span>
        </label>
    </li>
</template>

<script>
import { sheetState } from '../../../../../sheet-state'

export default {
    props: {
        value: Object
    },
    data() {
        return {
            sheetState,
        }
    },
    computed: {
        setting: function () {
            return this.sheetState.reservationSetting
        },
        palette: function () {
            return this.setting?.workCodeColorPaletteID?.basicPalette ?? []
        },
        isServerData: function () {
            return this.value._id != 'custom' && this.value._id != 'basic'
        },
        backgroundColorStyle: function () {
            let bgColorString = ''
            if (this.value.usingCustomColor == true) {
                bgColorString = this.value.customColorCode
            }
            else {
                bgColorString = this.palette?.[this.value?.paletteIndex]
            }
            return 'background-color:' + bgColorString
        },
        codeTitle: function () {
            switch (this.value._id) {
                case 'custom':
                    return this.$t( 'work_schedule.filter_overlay.label_show_custom_times')
                case 'basic':
                    return this.$t('work_schedule.filter_overlay.label_show_default_worker')
                default:
                    return this.value.title
            }
        }
    },
    methods: {
        action_SelectCode() {
            this.$emit('selectCode', this.value)
        }
    }
}
</script>

<style scoped>
    .check_wrap{
        display: inline-flex;
        width: 100%;
    }

    .code_title{
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
</style>